// root_url.js
import { ROOT_URL } from '../../config/root0';

// export const ROOT_URL = Config.COMPANY_ROOT_URL_DEV;
export const BASE_URL = `${ROOT_URL}/api`;



// WEBPACK FOOTER //
// ./src/api/root_url.js